import { selectApiData } from 'util/selector/apiSelector';
import { selectResponseData } from 'util/selector/axiosSelector';

import { AxiosInstance } from 'axios';

import { AccessCodeModel, mapAccessCodeDtoToModel } from './dto/AccessCode.dto';

export class AccessCodeApi {
  constructor(private client: AxiosInstance) {}

  unsubscribed(distributionId: string): Promise<AccessCodeModel[]> {
    return this.client
      .get(`api/v1/distribution/${distributionId}/access-codes?filter[subscribed]=0`)
      .then(selectApiData)
      .then((entries) => entries.map(mapAccessCodeDtoToModel));
  }

  search(distributionId: string, query: string): Promise<AccessCodeModel[]> {
    return this.client
      .get(
        `api/v1/distribution/${distributionId}/access-codes?query=${encodeURIComponent(
          query,
        )}&limit=100`,
      )
      .then(selectApiData)
      .then((entries) => entries.map(mapAccessCodeDtoToModel));
  }

  resendLastEmail(distributionId: string, accessCode: string): Promise<any> {
    return this.client
      .post(`api/v1/distribution/${distributionId}/resend-last-email/${accessCode}`)
      .then(selectResponseData);
  }

  resendFailedEmail(emailTemplateId: number, accessCode: string): Promise<any> {
    return this.client
      .post(`api/v1/email-template/${emailTemplateId}/resend/${accessCode}`)
      .then(selectResponseData);
  }

  resendEmail(emailTemplateId: number, email: string): Promise<any> {
    return this.client.post(`api/v1/email-template/${emailTemplateId}/resend/${email}`);
  }
}
